<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('btn.edit') : t('btn.add')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="arkCode"
        :label="t('operate.6rj8gj')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CusSelect appId="cos_ofbu" v-model:value="editForm.arkCode" @selectData="selectData" />
      </a-form-item>
      <a-form-item
        name="status"
        :label="t('operate.yfzy2e')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <a-select ref="select" v-model:value="editForm.status" :placeholder="t('common.pleaseSelect')">
          <!-- <a-select-option :value="BiOrderStatus.RUNNING">{{ t('enum.customerStaus31') }}</a-select-option> -->
          <a-select-option :value="BiOrderStatus.UP">{{ t('enum.customerStaus32') }}</a-select-option>
          <a-select-option :value="BiOrderStatus.DOWN">{{ t('enum.customerStaus33') }}</a-select-option>
          <a-select-option :value="BiOrderStatus.FLAT">{{ t('enum.customerStaus34') }}</a-select-option>
          <!-- <a-select-option :value="BiOrderStatus.LOSS">{{ t('enum.customerStaus36') }}</a-select-option> -->
        </a-select>
      </a-form-item>
      <a-form-item
        name="floatPercent"
        :label="t('operate.jbk0iz')"
        :rules="[{ required: true, message: t('common.pleaseInput') }]"
      >
        <a-input-number v-model:value="editForm.floatPercent" :maxlength="10" :placeholder="t('common.pleaseInput')" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiOrderStatus, updateBiOrderStatus } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiOrderStatusParams } from '@/typings/api/overseasSales'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { BiOrderStatus } from '../hooks/enum'
import { useI18n } from 'vue-i18n'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiOrderStatusParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiOrderStatusParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, floatPercent, status } = editForm.value
    const p = {
      arkCode,
      cosId,
      floatPercent,
      status
    }
    try {
      if (editForm.value.id) {
        await updateBiOrderStatus({ ...p, id: editForm.value.id })
      } else {
        await addBiOrderStatus(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
